module.exports = __webpack_public_path__ + "img/logo_galp.445834c0.png";